import { reducerCreator } from '@adrias-online/steiner';

import helper from '../../../helpers/steinerHelper';
import { actionTypes } from '../actions/portaliGalleries';
import { createHandlers } from '../../../helpers/portaleModuleHelper';

export const DEFAULT_STATE = helper.createDefaultState({
    list: {
        filters: {
            portaleId: null
        }
    }
});

const handlers = createHandlers(actionTypes, {
    items: 'data.data',
    total: 'data.meta.total'
});

export default reducerCreator.createReducer(handlers, DEFAULT_STATE);

export const selectors = reducerCreator.createSelectors('portaliGalleries');
